import { ReactNode } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { IMyPointsTutorialProps } from './my-points-tutorial.models';
import { ReactComponent as PointsTutorialIcon } from '../../../../../assets/images/points-tutorial.svg';
import { useStyles } from './my-points-tutorial.styles';
import { Tutorial } from '../../../../common/tutorial';
import { usePointsTutorial } from '../../../../../graphql/user/actions/pointsTutorial';
import { Button } from '../../../../common/button-new';

export const MyPointsTutorial = ({ onNavigate, onClose, ...props }: IMyPointsTutorialProps): JSX.Element => {
  const intl = useIntl();
  const classes = useStyles();
  const { setPointsTutorialShown } = usePointsTutorial();

  const handleTutorialClose = () => {
    setPointsTutorialShown();
    onClose!();
  };

  const handleHowToLinkClick = () => {
    onNavigate();
    setPointsTutorialShown();
  };

  return (
    <Tutorial
      {...props}
      data-testid="points-tutorial"
      onClose={handleTutorialClose}
      icon={(
        <PointsTutorialIcon
          data-testid="points-tutorial-logo"
        />
      )}
      title={(
        <FormattedMessage
          id="myPointsDetailed.tutorial.title"
        />
      )}
      description={intl.formatMessage(
        { id: 'myPointsDetailed.tutorial.description' },
        { sup: (chunks: ReactNode) => <sup>{chunks}</sup> },
      )}
      addLink={(
        <Button
          style="text"
          onClick={handleHowToLinkClick}
          rootClasses={classes.howToLink}
          data-testid="tutorial-howTo-link"
          isUnderline
        >
          <FormattedMessage
            id="myPointsDetailed.tutorial.howToLink.label"
          />
        </Button>
      )}
    />
  );
};
